import React from 'react';
import { ShopCheckoutCancel } from '../../components/shop/ShopCheckout/ShopCheckoutCancel';
import { useShopNavigation } from '../../hooks/useShopNavigation';

export const ShopCheckoutCancelPage = () => {
    const { navigateToShop } = useShopNavigation();

    return <ShopCheckoutCancel onContinueShopping={navigateToShop} />;
}
